import { useQuery } from '@tanstack/react-query';

const useEnv = () => {
  return useQuery({
    queryKey: ['app-envs'],
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
    initialData: {
      mode: process.env.NODE_ENV,
    },
  });
};

export { useEnv };
